import moment from "moment";
import { durationMinutes } from "./CalendarUtils";

const MAX_COLUMNS = 3;

/**
 * Lays out overlapping events into columns (max 3).
 * Returns array of { event, column, totalColumns }.
 */
export const layoutEvents = (events) => {
  if (!events.length) return [];

  const sorted = [...events].sort((a, b) => {
    const cmp = moment(a.start).diff(moment(b.start));
    if (cmp !== 0) return cmp;
    return durationMinutes(b) - durationMinutes(a);
  });

  const result = [];
  const columns = []; // columns[i] = array of events in that column

  for (const event of sorted) {
    let placed = -1;
    for (let col = 0; col < columns.length && col < MAX_COLUMNS; col++) {
      const lastInCol = columns[col][columns[col].length - 1];
      if (!moment(event.start).isBefore(moment(lastInCol.end))) {
        columns[col].push(event);
        placed = col;
        break;
      }
    }

    if (placed === -1) {
      if (columns.length < MAX_COLUMNS) {
        columns.push([event]);
        placed = columns.length - 1;
      } else {
        columns[MAX_COLUMNS - 1].push(event);
        placed = MAX_COLUMNS - 1;
      }
    }

    result.push({ event, column: placed, totalColumns: 0 });
  }

  const totalCols = columns.length;
  return result.map((r) => ({ ...r, totalColumns: totalCols }));
};

export { MAX_COLUMNS };
